// breadcrumbs-context.tsx
'use client' // Only needed for App Router

import { createContext, useContext, ReactNode, useState } from 'react'

type WikiContextType = {
  setBreadcrumbs: (breadcrumbs: ReactNode) => void
  setOnPageNav: (onPageNav: ReactNode) => void
  breadcrumbs: ReactNode
  onPageNav: ReactNode
}

const WikiContext = createContext<WikiContextType>({
  setBreadcrumbs: () => {},
  setOnPageNav: () => {},
  breadcrumbs: null,
  onPageNav: null,
})

export const WikiContextProvider = ({ children }: { children: ReactNode }) => {
  const [breadcrumbs, setBreadcrumbs] = useState<ReactNode>(null)
  const [onPageNav, setOnPageNav] = useState<ReactNode>(null)

  return (
    <WikiContext.Provider value={{ breadcrumbs, setBreadcrumbs, onPageNav, setOnPageNav }}>
      {children}
    </WikiContext.Provider>
  )
}

export const useWikiContext = () => useContext(WikiContext)
